module.exports = __webpack_public_path__ + "assets/img/6.f1f17f0b.png";